import Button from '../../../../components/button';
import Modal from '../../../../components/mazraeKit/modal';
import SpinnerLoading from '../../../../components/SpinnerLoading';

interface ICashOutModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onClick: () => void;
  isLoading?: boolean;
}

const CashOutModal = ({
  open,
  setOpen,
  onClick,
  isLoading = false,
}: ICashOutModalProps) => {
  return (
    <Modal
      isOpen={open}
      setIsOpen={() => {
        if (!isLoading) setOpen(true);
      }}
    >
      <div className="relative flex flex-col w-[90vw] items-center justify-center gap-6 p-6 bg-white rounded-full">
        {isLoading && (
          <div className="absolute inset-0 z-20 flex items-center justify-center rounded-full bg-white/60 backdrop-blur-sm">
            <SpinnerLoading size={48} />
          </div>
        )}

        <i
          className={`absolute text-2xl text-gray-700 icon-nameClose-remove top-4 left-4 ${
            isLoading ? 'pointer-events-none opacity-50' : 'cursor-pointer'
          }`}
          onClick={() => {
            if (!isLoading) setOpen(false);
          }}
        />

        <div className="flex flex-col items-center justify-center gap-2">
          <i className="text-5xl text-red-600 icon-warning-triangle" />
          <h1 className="mb-0 text-center text-md font-Medium">
            درخواست برداشت وجه
          </h1>
        </div>

        <span className="text-center text-md">
          از درخواست برداشت وجه اطمینان دارید؟
        </span>

        <div className="flex w-full gap-6">
          <Button
            onClick={() => setOpen(false)}
            variant="errorOutline"
            size="small"
            disabled={isLoading}
          >
            انصراف
          </Button>

          <Button
            onClick={onClick}
            variant="primary"
            size="small"
            disabled={isLoading}
          >
            برداشت وجه
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CashOutModal;
